/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function (root, doc) {
  'use strict';
  function en(pl, eng) { return /^en(?:-|$)/i.test(doc.documentElement.lang || '') ? eng : pl; }
  function json(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw Error(jst("pages_historia_odtwarzacz_js.607c825c7da3"));
      return r.json();
    });
  }
  function clear(el) { while (el && el.firstChild) el.removeChild(el.firstChild); }
  function init(box) {
    var game = box.dataset.gra || 'lotto', base = '/assets/json/db/' + game + '/';
    var years = box.querySelector('[data-historia-rok]'), status = box.querySelector('[data-historia-status]');
    var panel = box.querySelector('[data-historia-panel]'), slider = box.querySelector('[data-historia-suwak]');
    var label = box.querySelector('[data-historia-opis]'), balls = box.querySelector('[data-historia-kule]');
    var play = box.querySelector('[data-historia-play]'), timer = null, draws = [], loaded = false;
    function stop() { if (timer) root.clearInterval(timer); timer = null; play.textContent = jst("pages_historia_odtwarzacz_js.7e2933e89b86"); }
    function render() {
      if (!draws.length) return;
      var i = Math.max(0, Math.min(draws.length - 1, Number(slider.value) || 0)), d = draws[i] || {};
      slider.value = String(i); clear(balls);
      (d.numbers || []).forEach(function (n) { var b = doc.createElement('span'); b.className = 'kula kula--mala kula--' + game; b.setAttribute('role', 'listitem'); b.textContent = String(n); balls.appendChild(b); });
      if ((d.special || []).length) { var plus = doc.createElement('span'); plus.className = 'kule__plus'; plus.textContent = '+'; balls.appendChild(plus); }
      (d.special || []).forEach(function (n) { var b = doc.createElement('span'); b.className = 'kula kula--mala kula--specjalna'; b.setAttribute('role', 'listitem'); b.textContent = String(n); balls.appendChild(b); });
      var date = String(d.drawn_at || '').replace('T', ' ').slice(0, 16), id = (d.draw_system_id ?? d.legacy_id) == null ? '' : String((d.draw_system_id ?? d.legacy_id));
      label.textContent = (i + 1) + ' / ' + draws.length + ' · ' + date + (id ? jst("pages_historia_odtwarzacz_js.e0fff54aa0e1") + id : '');
    }
    function loadYear(year) {
      stop(); panel.hidden = true; status.textContent = jst("pages_historia_odtwarzacz_js.b5626f43dae3");
      json(base + 'rok-' + year + '.json').then(function (data) {
        draws = Array.isArray(data.draws) ? data.draws.slice() : [];
        draws.sort(function (a, b) { return (Date.parse(a.drawn_at) || 0) - (Date.parse(b.drawn_at) || 0); });
        if (!draws.length) throw Error(jst("pages_historia_odtwarzacz_js.7d804a3475f9"));
        slider.min = '0'; slider.max = String(draws.length - 1); slider.value = String(draws.length - 1);
        panel.hidden = false; status.textContent = jst("pages_historia_odtwarzacz_js.ca8a6253fdbb") + draws.length + jst("pages_historia_odtwarzacz_js.dd55a5bd32ec"); render();
      }).catch(function (e) { draws = []; panel.hidden = true; status.textContent = e.message; });
    }
    function firstLoad() {
      if (loaded) return; loaded = true; status.textContent = jst("pages_historia_odtwarzacz_js.974c9d176ffc");
      json(base + 'heatmap.json').then(function (data) {
        var list = Object.keys(data.lata || {}).filter(function (y) { return /^\d{4}$/.test(y); }).sort().reverse();
        if (!list.length) throw Error(jst("pages_historia_odtwarzacz_js.18bce03731ce"));
        clear(years); list.forEach(function (y) { var o = doc.createElement('option'); o.value = y; o.textContent = y; years.appendChild(o); });
        years.disabled = false; loadYear(list[0]);
      }).catch(function (e) { status.textContent = e.message; });
    }
    box.addEventListener('toggle', function () { if (box.open) firstLoad(); });
    years.addEventListener('change', function () { loadYear(years.value); });
    slider.addEventListener('input', function () { stop(); render(); });
    box.querySelector('[data-historia-prev]').addEventListener('click', function () { stop(); slider.value = String(Math.max(0, Number(slider.value) - 1)); render(); });
    box.querySelector('[data-historia-next]').addEventListener('click', function () { stop(); slider.value = String(Math.min(draws.length - 1, Number(slider.value) + 1)); render(); });
    play.addEventListener('click', function () {
      if (timer) { stop(); return; }
      if (Number(slider.value) >= draws.length - 1) slider.value = '0';
      play.textContent = jst("pages_historia_odtwarzacz_js.2a5c047d53af");
      timer = root.setInterval(function () { var n = Number(slider.value) + 1; if (n >= draws.length) { stop(); return; } slider.value = String(n); render(); }, 1200);
    });
  }
  function start() { doc.querySelectorAll('[data-historia-player]').forEach(init); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
